import { useEffect } from 'react'
import { getFeatureLayers } from './layerRegistry'

// Applies every layer registered in the layer manager (S15 extension point).
// Creates each registered source+layer once (when the base style is ready),
// then keeps its data + visibility in sync from `ctx` on every change. Inert
// while the registry is empty, so future gameplay systems (resources,
// logistics, …) plug in by calling registerFeatureLayer — no MapView changes.
export function useExtensionLayers(map, ctx) {
  useEffect(() => {
    if (!map.current || !map.current.getLayer('regions-fill')) return
    for (const def of getFeatureLayers()) {
      try {
        const data = def.data ? def.data(ctx) : { type: 'FeatureCollection', features: [] }
        const src = map.current.getSource(def.id)
        if (!src) {
          map.current.addSource(def.id, { type: 'geojson', data })
          map.current.addLayer({ ...def.layer, id: def.id, source: def.id }, def.beforeId)
        } else {
          src.setData(data)
        }
        const visible = def.visible ? !!def.visible(ctx) : true
        if (map.current.getLayer(def.id)) {
          map.current.setLayoutProperty(def.id, 'visibility', visible ? 'visible' : 'none')
        }
      } catch (e) {
        console.error(`[layerRegistry] failed to apply "${def.id}":`, e)
      }
    }
  }, [map, ctx])
}
